;function ShowModalPopUp(message, type) {
    popupV2({ title: "", content: message, type: type, pos: "", size: "sm", actions: [] });
}

function ShowMyModalPopUp(htmlBody, title, showFooter) {
    popupV2({ title: title, content: htmlBody, type: "", pos: "", size: "lg", actions: [] });
}

function HideModalPopUp(type) {
    if (type == 'loader') { $('#myLoaderModal').modal('hide'); }
    else if (type == 'mymodal') { $('#myModal').modal('hide'); }
}

function htmlEncode(value) {
    //create a in-memory div, set it's inner text(which jQuery automatically encodes)
    //then grab the encoded contents back out.  The div never exists on the page.
    return $('<div/>').text(value).html();
}

function htmlDecode(value) {
    return $('<div/>').html(value).text();
}

$(document).on("click", ".close", function () {
    $("#myModal .modal-title").removeClass("compareproductmodal");
    $("#myModal .modal-dialog").removeClass("modal-lg");
    $("#myModal .modal-body").removeClass("overflowHidden");
});



/// <summary>
/// Author  : Rohan Gaikwad
/// Date    : 17/01/2018
/// Scope   : Modal/Popup/Notification with callbacks
/// Version : 0.0.2
/// </summary>
/*
Changelog

Version 0.0.2 (2018-06-12)
- Changes
    - Specify whether to set the content as text or html
- Fixes
    - When multiple modals are opened, and first one is closed, 'modal-open' class gets removed from the body even when other modals are open in the background.

*/
var _openPopupCount = 0;
function popupV2(options) {
    if (_popupV2.debug) {
        console.log(popupV2.caller);
        console.log("Popup initialized with the following params: ",options);
    }		

    //default settings
    var _defaults = {
        title: "", content: "", type: "", size: "", actions: [], classes: "", backdrop: true, keyboard: true, pos: "", text: false, timeout: "", dismiss: false, btnType: "primary",
        show: function () { },
        shown: function () { },
        hide: function () { },
        hidden: function () { },
        close: function () { }
    };

    //override default settings
    var settings = $.extend({}, _defaults, options);

    // if modal size is specified, convert it to appropriate bootstrap class
    settings.size = (settings.size.length) ? "modal-" + settings.size : "";

    // clone the modal template
    var _modal = $('[data-id="modal-template"]').clone().removeAttr("data-id");

    if (settings.type == "notification") {
        settings.pos = (settings.pos.length) ? settings.pos : "9";
        settings.timeout = (settings.timeout == "") ? 10000 : settings.timeout;
        settings.backdrop = false;
        _modal.addClass("pe-none");
    }

    if (settings.pos == "1") {
        _modal.find(".modal-dialog").addClass("float-left");
    } else if (settings.pos == "2") {

    } else if (settings.pos == "3") {
        _modal.find(".modal-dialog").addClass("float-right");
    } else if (settings.pos == "4") {
        _modal.find(".modal-dialog").addClass("modal-dialog-centered float-left");
    } else if (settings.pos == "5") {
        _modal.find(".modal-dialog").addClass("modal-dialog-centered");
    } else if (settings.pos == "6") {
        _modal.find(".modal-dialog").addClass("modal-dialog-centered float-right");
    } else if (settings.pos == "7") {
        _modal.find(".modal-dialog").addClass("modal-dialog-bottom float-left");
    } else if (settings.pos == "8") {
        _modal.find(".modal-dialog").addClass("modal-dialog-bottom");
    } else if (settings.pos == "9") {
        _modal.find(".modal-dialog").addClass("modal-dialog-bottom float-right");
    }

    if (settings.type == "success" || settings.type == "warning" || settings.type == "error" || settings.type == "confirm" || settings.type == "info") {
        // default style for buttons based on the type of popup
        if (settings.type == "error") {
            settings.btnType = "danger";
        } else if (settings.type == "confirm") {
        } else {
            settings.btnType = settings.type;
        }

        if (!settings.title.length) {
            // If title is not defined, use the modal type text. Capitalize the first letter
            if(settings.type.length > 1) {
                settings.title = settings.type.charAt(0).toUpperCase() + settings.type.slice(1);
            }            
        }

    } else {
        if (settings.actions.length == 0) { 
            _modal.find(".modal-footer").hide();
        }
    }

    if (settings.actions.length) { 
        _modal.find(".modal-footer").empty();
    } else {
        _modal.find(".modal-footer .btn").removeClass("btn-primary").addClass("btn-" + settings.btnType);
    }

    settings.actions.forEach(function (action, index) {
        if (action.do == undefined) action.do = function () { };
        var _button = $('<button type="button" class="btn btn-' + settings.btnType +'"><i class="fa"></i><span>' + action.text + '</span></button>');
        if (settings.type == "confirm" || action.dismiss) { 
            _button.attr("data-dismiss", "modal");
        }
        _button.click( function () { action.do() } );
        _button.appendTo(_modal.find(".modal-footer"));
    });


    _modal.find("h5.modal-title").html(settings.title);
    if(settings.text){
        _modal.find(".modal-body").text(settings.content);
    } else {
        _modal.find(".modal-body").html(settings.content);
    }    
    _modal.find(".modal-dialog").addClass(settings.size).addClass(settings.type).addClass(settings.classes);
    _modal.attr("data-class",settings.classes);
    _modal.appendTo("body");
    _modal.modal({
        show: true,
        keyboard: settings.keyboard,
        backdrop: settings.backdrop
    });

    if (settings.type == "notification") {
        $("body").addClass("notification-open");
    }

    // events
    _modal.on('show.bs.modal', function (e) {
        settings.show();
    });
    _modal.on('shown.bs.modal', function (e) {
        if (settings.type == "notification") {
            $("body").removeClass("modal-open");
        }
        settings.shown();
        
        if(settings.type != "notification") {
            _openPopupCount++;
        }
    });
    _modal.on('hide.bs.modal', function (e) {
        settings.hide();
    });
    _modal.on('hidden.bs.modal', function (e) {
        settings.hidden();
        settings.close();
        _modal.remove();
        $("body").removeClass("notification-open");

        if(settings.type != "notification") {
            _openPopupCount--;
            if(_openPopupCount){
                $('body').addClass('modal-open');
            }
        }
    });

    if (settings.timeout != "") { 
        setTimeout(function () {
            // automatically hide popup, only if no actions are defined
            if (!settings.actions.length) _modal.modal('hide');
        }, settings.timeout);
    }
    
}

function closePopupV2(options) {

    //default settings
    var _defaults = { delay: 0, target: '' };
    //override default settings
    var settings = $.extend({}, _defaults, options);

    settings.target = settings.target.trim();
    if (settings.target.length == 0) {
        console.error("Please specify the className of the popup to be closed.");
    } else {
        var _closeButton = $("." + settings.target).closest(".modal").find("button.close");
        if (_closeButton.length == 0) {
            console.error("The popup has no close button.");
        } else {
            setTimeout(function () { 
                _closeButton.trigger("click");
            }, settings.delay);				
        }
    }

}

_popupV2 = {
    debug: false
};